import { Button, Icon, Loading, Modal, Typography } from "@/components/atoms";

interface UpdateDriverEmailModalProps {
  open: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const UpdateDriverEmailModal = ({ open, isLoading, onClose, onContinue }: UpdateDriverEmailModalProps) => {
  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={handleClose} variant="web-small">
      {isLoading && <Loading />}
      <div className="w-full px-6 py-8">
        <div className="text-center">
          <div className="flex items-center justify-center">
            <div className="mb-4 flex items-center justify-center rounded-lg bg-warning-light p-3">
              <Icon name="Warning2" variant="Bold" size={36} className="text-warning" />
            </div>
          </div>
          <Typography variant="h1">Update Login Email</Typography>
          <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
            This will update the login email for this account. They will need to log in with the new email before it
            takes effect.
          </Typography>
        </div>

        <div className="mt-8 flex flex-col-reverse gap-3 md:flex-row">
          <Button onClick={handleClose} variant="secondary" className="w-full md:flex-1" size="lg">
            Cancel
          </Button>
          <Button onClick={onContinue} className="w-full md:flex-1" size="lg">
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};
